
/**
 * @name APP cmmApp
 * @autor daniel.molina@u-planner.com
 * @description vista tabla para forecast
 * # name controller --> powerbiPortofolioCtrl
 * # alias: --> powerbiCtrl
 */
 export default class powerbiPortfolioCtrl{
	constructor($http, $scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant,LOCAL_ENV_CONSTANT) {
           
           	$scope.title='Reporte portafolio de profesores'

           	$scope.POWER=LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_REPORT.REPORT_FACULTY1;

           	$scope.workspaceId=LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_GROUP_ID;
           	$scope.reportId=LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_REPORT.REPORT_FACULTY1;
   }

}

powerbiPortfolioCtrl.$inject = ['$http', '$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant','LOCAL_ENV_CONSTANT'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/portfolioPowerbi/powerbiPortfolioCtrl.js